import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        tabBar: 'index'
    },
    mutations: {},
    actions: {},
    modules: {}
})
